// components/PodcastDrawerContent.tsx
import React, { useEffect, useRef, useState } from "react";
import { ImCross } from "react-icons/im";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../../thoughts/chat/RenderResponse";
// import { markdownComponents } from "../RenderResponse";

interface Props {
  citation: {
    title: string;
    link: string;
  };
  podcastText?: string;
  podcastError?: string | null;
  onClose: () => void;
}

const PodcastViewerInDrawer: React.FC<Props> = ({
  citation,
  podcastText,
  podcastError,
  onClose,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [showDivider, setShowDivider] = useState(false);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const handleScroll = () => {
      const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
      setShowDivider(!atBottom);
    };

    handleScroll(); 
    el.addEventListener("scroll", handleScroll);

    return () => el.removeEventListener("scroll", handleScroll);
  }, [podcastText]);

  return (
    <div className="flex flex-col h-full">
      <div className="p-3 flex items-center justify-between">
        <ImCross onClick={onClose} className="cursor-pointer" />
        <p className="text-2xl text-center flex-1 text-ellipsis overflow-hidden whitespace-nowrap">{citation.title}</p>
      </div>

      <div className="flex-1 overflow-auto p-4 pr-2" ref={containerRef}>
        {podcastError ? (
          <div className="flex h-full justify-center items-center text-2xl">
            {podcastError}
          </div>
        ) : (
          podcastText && (
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              remarkPlugins={[remarkGfm]}
              components={markdownComponents}
            >
              {podcastText}
            </ReactMarkdown>
          )
        )}
      </div>

      {showDivider && (
        <div className="w-full h-px bg-gray-100 shadow-2xl opacity-50 duration-200 ease-in-out " />
      )}
      <div className="p-2 bg-inherit">
        <div className="flex flex-col items-center text-center">
          <div className="px-2">
            <span>Listen to the podcast: </span>
            <a
              href={citation.link}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer text-blue-600 hover:underline break-all"
            >
              {citation.link}
            </a>
          </div>
          <div className="px-2  text-sm card_text_color">
            <strong>Important:</strong> This summary is automatically generated
            using AI and may not reflect the full content of the podcast.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PodcastViewerInDrawer;
